<template>
  <el-popover placement="bottom-start" trigger="click">
    <div style="font-size: 16px;text-align: center;">
      <p>你好</p>
      <p><small>北京时间 <span v-text="timeNow"></span></small></p>
    </div>
    <i class="el-icon-user-solid" style="margin-right: 15px" slot="reference" @click="handleTimeShow()"></i>
  </el-popover>
</template>

<script>
export default {
  name: 'UserSetting',
  data () {
    return {
      timeNow: new Date().toLocaleString()
    }
  },
  methods: {
    handleTimeShow () {
      this.timeNow = new Date().toLocaleString()
    }
  }
}
</script>

<style scoped>
  .el-popover{
    background: #B4C0D2;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout/UserSetting.vue